<template>
  <img alt="Cargando" class="w-24 h-24 mx-auto" src="/images/loading.svg" v-if="componentReady == 'loading'">
  <div class="p-4 rounded text-red-600 border border-red-600 text-center leading-none" v-else-if="componentReady == 'error'">
    <p class="font-bold mb-1">Variantes no cargadas</p>
    <p class="text-sm">Lo sentimos, pero ocurrió algo extraño y no pudimos las variantes de este producto. Por favor, intenta nuevamente.</p>
  </div>
  <div v-else>
    <div class="border rounded p-4"v-if="products.length > 1">
      <p class="mb-2">Este producto también está disponible en estas opciones:</p>
    
      <template v-if="!hasOnlyColor">
        <div class="mb-2 pb-2 border-b" :key="`filter-${i}`" v-for="(confiAttribute, i) in configAttributes">
          <p class="font-bold">{{ confiAttribute.name }}</p>
          <div class="overflow-hidden">
            <div class="flex flex-row flex-wrap -mx-1 text-sm">
              <div
                class="w-32 px-1 text-center"
                :key="`option-${i}-${j}`"
                v-for="(option, j) in confiAttribute.options">
                <div
                  :class="configurableOptions[confiAttribute.id] == option.id ? 'border-main text-main' : ''"
                  @click="updateFilter(confiAttribute.id, option.id)"
                  class="p-1 border rounded hover:text-main hover:border-main cursor-pointer st-all"><div class="inline-block rounded-full w-4 h-4 border align-middle" :style="{backgroundColor: option.extras.hex}" v-if="confiAttribute.type == 'COLOR'"></div> {{ option.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <img alt="Cargando" class="w-24 h-24 mx-auto" src="/images/loading.svg" v-if="productsReady == 'loading'">
      <div class="p-4 rounded text-red-600 border border-red-600 text-center leading-none" v-else-if="productsReady == 'error'">
        <p class="font-bold mb-1">Variantes no cargadas</p>
        <p class="text-sm">Lo sentimos, pero ocurrió algo extraño y no pudimos las variantes de este producto. Por favor, intenta nuevamente.</p>
      </div>
      <template v-else>
        <p class="text-center py-2 text-gray-700 " v-if="products.length == 0">No hay variantes que coincidan con estas opciones</p>
        <div class="overflow-hidden" v-else>
          <div class="flex flex-row flex-wrap text-center justify-center items-stretch leading-tight text-sm -mx-2">
          <div class="w-1/2 sm:w-1/3 md:w-1/3 lg:w-1/2 xl:w-1/3 px-2 mb-4" :key="`product-${i}`" v-for="(product, i) in products">
            <div class="border rounded p-2 hover:border-main st-border h-full">
              <div class="mb-2">
                <a :href="`/productos/${product.slug}`" :title="`Ver detalles de ${product.slug}`"><img :src="product.image" :alt="product.name" class="inline"></a>
              </div>
              <div class="mb-2"><a :href="`/productos/${product.slug}`" :title="`Ver detalles de ${product.slug}`" class="link-basic">{{ product.name }}</a></div>
              <div class="leading-none">
                <p class="text-xs text-main" v-if="product.has_special_promo_price">Promoción:</p>
                <p class="md:text-lg font-bold"><a :href="`/productos/${product.slug}`" class="text-main" :title="`Ver detalles de ${ product.name }`"><span class="text-sm">$</span>{{ product.selling_price_whole_part }}.<span class="price-decimals">{{ product.selling_price_decimal_part }}</span></a></p>
                <p class="inline-block ml-1 line-through text-gray-700 text-sm" v-if="product.has_promo_price">{{ product.regular_price }}</p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'configurable-options',
  props: {
    productSlug: { type: String, default: '' },
    productAttributes: { type: Object, default() { return {} } },
    configurable: { type: String, default: '' },
  },
  data() {
    return {
      hasOnlyColor: false,
      componentReady: 'loading',
      productsReady: 'loading',
      configAttributes: [],
      products: [],
      configurableOptions: {}
    }
  },
  mounted() {
    this.loadConfigurable();
  },
  methods: {
    loadConfigurable: async function() {
      try {
        let res = await axios.post(`/productos/variantes`, {slug: this.productSlug});
        let { data } = await res.data;

        // if (data.has_color && data.filters.length == 1) {
        //   this.hasOnlyColor = true;
        // }
        if (data.filters.length == 1) {
          this.hasOnlyColor = true;
        }
        
        this.configAttributes = data.filters;
        data.filters.forEach(confFilter => {
          this.configurableOptions[confFilter.id] = this.productAttributes[confFilter.name].id;
        });

        this.loadProducts();

        this.componentReady = 'ready';
      } catch(e) {
        this.componentReady = 'error';
      }
    },
    loadProducts: async function() {
      try {
        let res = await axios.post(
          `/productos/variantes/buscar`,
          {
            options: this.configurableOptions,
            configurable: this.configurable,
            only_color: this.hasOnlyColor
          }
        );

        let { data } = await res.data;
        this.products = data;

        this.productsReady = 'ready';
      } catch(e) {
        this.productsReady = 'error';
      }
    },
    updateFilter(filterId, optionId) {
      this.configurableOptions[filterId] = optionId;
      this.loadProducts();
    }
  }
}
</script>